<template>
    <div class="headDiv">
        <div class="headsWrap">
        <div class="header">
        <div class="top" style="background:#fff">
            <div class="nav_top">
                <a href="http://www.lepu.cn/" class="logo tongji" data-tongji="首页logo">
                    <img src="https://assets.lepucdn.cn/p/v/images/index/index_logo.jpg" alt="乐铺logo" class="logo-img">
                </a>
                <dl class="city" v-on:mouseover="changeCity($event)" v-on:mouseout="removeCity($event)">
                    <dt>
                        <span>{{defaultCity}}</span>
                        <i v-if="cityFlag" class="iconfont icon-sanjiao-copy-copy" style="color:#de4b4f"></i>
                        <i v-else class="iconfont icon-sanjiao-copy-copy-copy"></i>
                    </dt>
                    <dd >
                        <ul class="allCity">
                            <li v-for="val in cityList" :key="val.city_id" @click="toggleCity(val)">
                                {{val.city_zh}}
                            </li>
                        </ul>
                    </dd>
                </dl>
                <div class="list">
                    <a href="http://www.lepu.cn/" class="tongji bg" data-tongji="首页">首 页</a>
                    <a href="http://www.lepu.cn/shop/" class="tongji" data-tongji="找铺开店">找铺开店</a>
                    <a href="http://www.lepu.cn/zhuanpu/" class="tongji" rel="nofollow" data-tongji="转店/出租">转店/出租</a>
                    <a href="http://www.lepu.cn/zhaopu/" class="tongji" rel="nofollow" data-tongji="订制找店">订制找店</a>
                    <a href="http://www.lepu.cn/demand/" class="tongji" rel="nofollow" data-tongji="求租信息">求租信息</a>
                    <a href="http://bbs.lepu.cn/" target="_blank" rel="nofollow">开店论坛</a>
                    <a href="http://www.lepu.cn/app/down" v-on:mouseover="changeActive($event)" v-on:mouseout="removeActive($event)" class="app_icon tongji" target="_blank" rel="nofollow" data-tongji="顶部下载APP">
                        <i class="icon iconfont app_down">&#xe664;</i>下载APP
                        <div class="nav_code" v-if="downApp">
                            <img src="https://assets.lepucdn.cn/p/v/images/index/index_code.png" alt="">
                        </div>
                    </a>
                </div>

                <div class="rexian">
                    <a class="tongji" v-if="loginFlag" rel="nofollow" data-tongji="顶部登录/注册" href="//www.lepu.cn/user/member" id="login_btn"><i class="icon iconfont">&#xe662;</i><span style="color:#333">我的乐铺</span></a>
                    <a class="tongji" v-else rel="nofollow" data-tongji="顶部登录/注册" href="//www.lepu.cn/login" id="login_btn"><i class="icon iconfont">&#xe662;</i><span style="color:#333">登录</span></a>
                    <em>|</em>
                    <b><i class="icon iconfont">&#xe663;</i></b><span>010-57271111</span>
                </div>

            </div>
        </div>
    </div>
    </div>
    </div>
</template>
<script>
export default {
    name: "Heads",
    data(){
        return{
            downApp:false,
            cityList:[], //城市数据
            defaultCity:'', //默认选中城市
            cityFlag:false,
            loginFlag:false, //判断当前是否登录
        }
    },
    methods:{
        changeActive($event){
            this.downApp = true
        },
        removeActive($event){
            this.downApp = false
        },
        changeCity(){
            this.cityFlag = true
        },
        removeCity(){
            this.cityFlag = false
        },
        //选择城市
        getCity(){
            this.ajax.get('//api.lepu.cn/app/shop/config-city').then(res=>{
                var res = res.data
                if(res.data.code == 1){
                    this.cityList = res.data.all_city
                    this.defaultCity = res.data.all_city[0].city_zh
                }
            })
        },
        toggleCity(val){
            this.defaultCity = val.city_zh
            this.ajax.get('//api.lepu.cn/app/index/change-city?city_id='+val.city_id).then(res=>{
                var res = res.data
                if(res.data.code == 1){
                    location.href="//www.lepu.cn/" + val.city_en
                }else{
                    location.href="//www.lepu.cn/"
                }
            })
        },
        // 判断是否登录
        getLogin(){
            this.ajax.get('//api.lepu.cn//app/usercenter/islogin').then(res=>{
                var res = res.data
                if(res.data.code == 1){
                    this.loginFlag = true
                }else{
                    this.loginFlag = false
                }
            })
        }
    },
    created(){
        this.getCity()
        this.getLogin()
    }
}
</script>
<style lang="scss" scoped>
.headDiv{
    width:100%;
    height: 60px;
    border-bottom: 1px solid #e5e5e5 
}

.headsWrap{
    width: 1200px;
    height: 60px;
    margin: 0 auto;
}
</style>